import styled from "styled-components";
import { breakpoints, colors } from "definitions";

export const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  height: 8rem;

  ${breakpoints.laptop} {
    /* El burger está posicionado en absoluto: se reserva su espacio para que el
       botón del evento no termine debajo. */
    min-width: 10rem;
    justify-content: flex-end;
  }
`;

export const Burger = styled.div`
  width: 2rem;
  height: 2rem;
  z-index: 1100;
  display: none;
  cursor: pointer;

  ${breakpoints.laptop} {
    display: flex;
    justify-content: space-around;
    flex-flow: column nowrap;
    position: absolute;
    top: 50%;
    right: 65px;
    transform: translateY(-50%);
  }

  div {
    width: 2rem;
    height: 0.25rem;
    background-color: ${({ open, overlay }) =>
    open
      ? `${colors.navigation.lightGray}`
      : overlay
        ? `${colors.icons.white}`
        : `${colors.navigation.gray}`};
    border-radius: 10px;
    transform-origin: 1px;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                opacity 0.2s ease,
                background-color 0.2s ease;
    &:nth-of-type(1) {
      transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
    }
    &:nth-of-type(2) {
      transform: ${({ open }) => (open ? "translateY(100%)" : "translateY(0)")};
      opacity: ${({ open }) => (open ? 0 : 1)};
    }
    &:nth-of-type(3) {
      transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
    }
  }
`;
